<template>
  <div class="page page-diary-image-list">
    <div class="image-list"
         :class="{ active: fromPage === 'workDetail' }"
    >
      <div class="image-block-item"
           v-for="(item, index) in list"
           :key="index"
      >
        <template v-if="item.list.length > 0">
          <div class="date"
               v-if="fromPage === 'diaryDetail'"
          >
            <span class="day">{{ formatDay(item.dateTime) }}</span>
            <span class="month">{{ formatMonth(item.dateTime) }}月</span>
          </div>
          <div class="diary-image-list">
            <image-list :list="item.list"
                        show-more
                        :page-type="page"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatTime } from '@/utils';
  import ImageList from '@/pages/ProjectWork/components/ImageList';
  import { getDiaryIndexData, getProjectWorkInfo } from '@/services/project-work';

  export default {
    name: 'imageBlock',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      ImageList,
    },
    data() {
      return {
        list: [],
        fromPage: '',
        projectId: 0,
        userId: 0,
        page: '',
        render: {
          pageTitle: '',
        },
      };
    },
    methods: {
      formatDay(timeStamp) {
        return formatTime(timeStamp, 'dd');
      },
      formatMonth(timeStamp) {
        const month = formatTime(timeStamp, 'MM');
        if (month < 10) return month.slice(1, 2);
        return month;
      },

      compare(p) {
        return function (m, n) {
          return m[p] - n[p]; // 升序
        };
      },
      formatDiaryImgList(list) {
        list.map((item) => {
          if (item.diary) {
            item.diary.images.sort(this.compare('index'));
          }
          return item;
        });
        return list;
      },
      async fetchDiaryData(projectId, userId) {
        const data = await getDiaryIndexData(projectId, userId, 'diary');
        this.render = data.render;
        const list = this.formatDiaryImgList(data.list);
        list.forEach((item) => {
          const obj = {
            dateTime: item.dateTime,
            list: item.diary ? item.diary.images : [],
          };
          this.list.push(obj);
        });
        this.fromPage = 'diaryDetail';
      },
      async fetchWorkDetailData(projectId, userId) {
        const data = await getProjectWorkInfo(projectId, userId, 'work');
        this.render = data.render;
        const { list } = data.workImgs;
        const obj = {
          list,
        };
        this.list.push(obj);
        this.fromPage = 'workDetail';
      },
    },
    created() {
      const { $route } = this;
      const { query } = $route;
      this.projectId = Number(query.id);
      this.userId = Number(query.userId);
      this.page = query.page;
      if (this.page === 'work') {
        this.fetchWorkDetailData(this.projectId, this.userId);
      } else {
        this.fetchDiaryData(this.projectId, this.userId);
      }
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-diary-image-list {
    background: @color-white;
    height: 100%;
  }

  .image-list {
    display: flex;
    flex-direction: column;
    &.active {
      padding-left: @size-medium;
    }
  }

  .image-block-item {
    display: flex;
  }

  .date {
    width: 210px;
    padding-left: @size-base;
    box-sizing: border-box;
    color: @color-text-base;
    font-weight: @font-weight-bold;
    .day {
      line-height: 1;
      font-size: @font-size-largest;
    }
    .month {
      margin-left: @size-small;
      font-size: @font-size-base;
    }
  }

  .diary-image-list {
    margin-top: @size-large;
    width: 100%;
    margin-bottom: @size-extra-medium;
  }
</style>
